import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import RightArrow from '../images/right-arrow.svg'
import Smile from '../images/smile.svg'
import Quotes from '../components/Quotes/Quotes.jsx'
const Lab = ({ data }) => {
  const { edges: portfolioItems } = data.allMarkdownRemark
  return (
    <div className="main-wrapper animated fadeIn">
      <h1>
        my lab
        <span className="title-end">_</span>
      </h1>
      <div className="subtitle">
        Showcase of work I've done for clients and personal projects
      </div>
      <Quotes />
      <div className="work-listing">
        {portfolioItems.map(({ node: pItem }) => {
          const { frontmatter } = pItem
          return (
            <div className="portfolio-item" key={frontmatter.path}>
              <Link to={`${frontmatter.path}`}>
                <div className="portfolio-item-thumbnail">
                  <Img
                    sizes={frontmatter.featuredImage.childImageSharp.sizes}
                    className="thumbnail"
                  />
                </div>
                <div className="portfolio-item-title">
                  <span>{frontmatter.type}</span>
                  {frontmatter.title}
                </div>
                <div className="next-arrow">
                  <img src={RightArrow} alt="Phanor Coll" />
                </div>
              </Link>
            </div>
          )
        })}
      </div>
      <div className="subtitle content">
        like what you see?
        <img src={Smile} alt="Phanor Coll" />
        <Link className="a-animation standout" to="/contact">
          contact me
        </Link>{' '}
        and lets bring your ideas to life.
      </div>
    </div>
  )
}

export const query = graphql`
  query PortfolioQuery {
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { category: { eq: "portfolio" } } }
    ) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            path
            type
            featuredImage {
              childImageSharp {
                sizes(maxWidth: 491) {
                  ...GatsbyImageSharpSizes
                }
              }
            }
          }
        }
      }
    }
  }
`

export default Lab



// WEBPACK FOOTER //
// ./src/pages/lab.js